export default __webpack_public_path__ + "static/Profile-d49f5b5eb7e6c7c543dfedd8b6b95efd.jpg";